import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingItemDto } from '../../../shared/modules/pricing-items/dtos/pricing-item.dto';
import { TagDto } from '../../tags/dtos/tag.dto';
import { VehicleMaintenanceRecordCategoryEnum } from '../enums/vehicle-maintenance-record-category.enum';

/**
 * Create vehicle maintenance DTO
 */
export class CreateVehicleMaintenanceDto {
  color?: string | null;
  notes?: string | null;
  externalReference?: string | null;
  recordCategory!: VehicleMaintenanceRecordCategoryEnum;
  @TransformDate()
  startsAt!: Date;
  @TransformDate()
  endsAt!: Date;
  @TransformFloat()
  estimatedCost?: number | null;
  description?: string | null;
  serviceCenter?: string | null;
  @TransformInt()
  vehicleId?: number | null;
  @TransformInt()
  supplierId?: number | null;
  @TransformInt()
  rentalAgreementId?: number | null;
  @TransformInt()
  vehicleDamageId?: number | null;
  @TransformInt()
  vehicleRoadWorthyCheckId?: number | null;
  pricingItems?: PricingItemDto[] | null;
  tags?: TagDto[] | null;
  files?: FileDto[] | null;
}
